import QuestionViewVerbal from "./QuestionViewVerbal";
import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbalMultiples extends QuestionViewVerbal {
    constructor(question) {
        super(question);
        if (question.input !== 'keypad') {
            this._inputField.visible = false;
        }
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        } else {
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);

        let text = this._template ? this._template.text : "";

        const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
        for (const i in values) {
            if (values.hasOwnProperty(i)) {
                if (i === "[VALUE0]") {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }
        }

        const length = this.generateValues(this._template.text, /\[LENGTH]/g);
        for (const i in length) {
            if (length.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), Math.random() < 0.5 ? this._question.length : converter.toWords(this._question.length));
            }
        }

        const match = text.match(/\. [a-z]/g);
        if (match) {
            for (let i = 0; i < match.length; ++i) {
                const s = match[i];
                text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
            }
        }

        return text;
    }

    setAnswer(value) {
        this._inputValue = value;
        if (this._question.input === 'keypad') {
            super.setAnswer(value);
        }
    }

    isCorrect() {
        let sum = 0;
        let answer = 0;
        if (this._inputValue.length) {
            for (let i = 0; i < this._inputValue.length; i++) {
                sum += this._inputValue[i].value;
            }
            for (let i = 0; i < this._question.part.length; i++) {
                answer += Number(this._question.options[this._question.part[i]]);
            }
        }
        else {
            sum = this._inputValue.value;
            answer = this._question.options[0].value;
        }
        return sum === answer;
    }

    filterTemplate(x) {
        return true;
    }
}